export default [
  {
    path: '/real-estate-developments/:id/parameters/new',
    name: 'RealEstateDevelopmentsParametersCreate',
    component: () => import('pages/real-estate-developments/tabs/parameters/form/ParametersForm.vue')
  },
  {
    path: '/real-estate-developments/:parentId/parameters/:id/edit',
    name: 'RealEstateDevelopmentsParametersEdit',
    component: () => import('pages/real-estate-developments/tabs/parameters/form/ParametersForm.vue')
  }
]
